import React from 'react';
import { useDesignMode } from '../../contexts/DesignContext';
import { classNames } from '../../utils/classNames';

export const SketchInput = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, ...props }, ref) => {
  const { isSketchy } = useDesignMode();

  return (
    <input
      ref={ref}
      className={classNames(
        isSketchy
          ? 'sketch-input w-full pb-1'
          : 'w-full px-4 py-2 border rounded-lg text-sm bg-[var(--color-surface)] border-[var(--color-border)] text-[var(--color-text)] focus:outline-none focus:ring-2 focus:ring-[var(--btn-primary-ring)]',
        className
      )}
      {...props}
    />
  );
});

SketchInput.displayName = 'SketchInput';

export const SketchTextarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => {
  const { isSketchy } = useDesignMode();

  return (
    <textarea
      ref={ref}
      className={classNames(
        isSketchy
          ? 'sketch-input w-full min-h-[120px] pb-1 resize-y'
          : 'w-full px-4 py-2 border rounded-lg text-sm bg-[var(--color-surface)] border-[var(--color-border)] text-[var(--color-text)] focus:outline-none focus:ring-2 focus:ring-[var(--btn-primary-ring)]',
        className
      )}
      {...props}
    />
  );
});

SketchTextarea.displayName = 'SketchTextarea';
